import React from "react";
import styled from "styled-components";
import {ButtonWidget} from "../../../widget/pub/button_widget";

export const SuccessWidget: React.FC<{onDismiss?:()=>void}> = ({onDismiss}) => {
    return (
        <SuccessStyle>
            <h2>Application success</h2>
            <ButtonWidget size={{x:8,y:40}} text={'Done'} onClick={onDismiss} />
        </SuccessStyle>
    );
}


const SuccessStyle = styled.div`
  width: 368px;
  height: 222px;
  background: linear-gradient(270deg, #E3EFFF 0%, #FAF0FF 100%);
  box-shadow: 0px 0px 16px 1px rgba(126, 126, 126, 0.45);
  border-radius: 12px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  h2 {
    font-size: 18px;
    font-weight: 400;
    color: #188058;
    margin-bottom: 20px;
  }

`
